import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useIntl } from 'react-intl';
import { TextField, InputAdornment } from '@material-ui/core';

const styles = () => ({
    textField: {
        width: '100%',
    },
    disabled: {},
    focused: {},
});

type FormInputProps = {
    form?: any;
    formItemKey?: any;
    initialValue?: any;
    label?: string;
    helperText?: string;
    placeholder?: string;
    additionalRules?: any[];
    classes?: any;
    type?: string;
    rows?: number;
    rowsMax?: number;
    fullWidth?: boolean;
    isRequired?: boolean;
    isLoading?: boolean;
    multiline?: boolean;
    validateTrigger?: string;
    onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>;
    disabled?: boolean;
    addonBefore?: boolean;
    preserve?: boolean;
}

/**
 * FormInput
 * - common component for inputs within console app
 */
const FormInput = ({
    form,
    formItemKey,
    initialValue,
    label = '',
    helperText = '',
    placeholder,
    additionalRules = [],
    classes,
    type = 'text',
    rows = 1,
    rowsMax = 3,
    fullWidth = false,
    isRequired = false,
    isLoading = false,
    multiline = false,
    validateTrigger = 'onChange',
    onChange,
    disabled = false,
    addonBefore = false,
    preserve = true,
}: FormInputProps): React.ReactElement => {
    const { getFieldDecorator } = form;

    const errors = form.getFieldError(formItemKey);

    const { formatMessage } = useIntl();

    return (
        <div className={label ? 'yeself-form-label-input' : 'yeself-form-input'}>
            {getFieldDecorator(formItemKey, {
                initialValue: initialValue || undefined,
                preserve,
                validateTrigger,
                rules: [
                    {
                        required: isRequired,
                        message: formatMessage({ id: 'Form.field.isRequired' }),
                    },
                    ...(additionalRules && additionalRules.length > 0 ? additionalRules : []),
                ],
            })(
                <TextField
                    required={isRequired}
                    id={`form-item-input-${formItemKey}`}
                    label={label || undefined}
                    fullWidth={fullWidth}
                    disabled={disabled || isLoading}
                    error={errors && errors.length > 0}
                    helperText={errors && errors.length > 0 ? errors.join(',') : helperText}
                    placeholder={placeholder || undefined}
                    variant="standard"
                    type={type}
                    rows={rows}
                    rowsMax={rowsMax}
                    multiline={multiline}
                    className={classes.textField}
                    onChange={onChange}
                    InputProps={{
                        startAdornment: addonBefore ? (
                            <InputAdornment position="start">{addonBefore}</InputAdornment>
                        ) : undefined,
                        classes: {
                            root: classes.filledInputRoot,
                            underline: classes.underline,
                            input: classes.filledInputInput,
                        },
                    }}
                    InputLabelProps={
                        fullWidth
                            ? {
                                  shrink: true,
                              }
                            : {}
                    }
                />
            )}
        </div>
    );
};
export default withStyles(styles)(FormInput);
